import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import PleaseWait from '../../components/PleaseWait'
import { logout } from '../../state/actions/session'

export const Logout = () => {
  const dispatch = useDispatch()

  // Sign out here rather than in prepareAsyncData: that hook is not awaited on
  // client-side transitions, so the page used to redirect ~250ms later whether
  // or not POST /ua/logout had come back — and the session lives in the `sid`
  // cookie, so navigating away before its response lands loses the Set-Cookie
  // that expires it and the browser stays signed in. (During server-render it
  // was worse: the logout ran against the renderer's cookies, never the
  // browser's.) Awaiting the call keeps the sign-out effective.
  //
  // Then leave via a document load instead of dispatching a route change.
  // Routing client-side kept the previous user's app alive: its SWR hooks
  // stayed mounted and carried on polling with the old session cookie, and
  // lib-core's module-level onLoginUrl (set by the access-denied/registration
  // gates) still pointed at one of their pages — so the next person to sign in
  // in this tab could be sent to the previous user's page. A real navigation
  // drops all of it, the same way lib-core's own sign-out (MyProfileIcon) does.
  useEffect(() => {
    const signOut = async () => {
      try {
        await dispatch(logout())
      } catch (err) {
        // leaving the app matters more than the outcome of the call
      }
      window.location.replace('/welcome')
    }
    signOut()
  }, [])

  return <PleaseWait i18nKey="logout.signing_out" />
}

export default Logout
